import CheckmarkIcon from '@ordr-as/icons/CheckmarkIcon';

const EmptyState = ({ label }: { label: string }) => (
  <div className="text-center text-grey-dark py-9 px-4">
    <CheckmarkIcon width={40} height={40} className="mx-auto mb-3 text-grey-medium" />
    <h3 className="m-0 mb-1 text-brand-secondary">All caught up</h3>
    <p className="m-0 text-small">No active orders for {label} right now.</p>
  </div>
);

export default EmptyState;
